import React from "react"
import Layout from "../../../components/Layout"
import Hero from "../../../components/Hero"
import Breadcrumb from "../../../components/Breadcrumb"
import Searcher from "../../../components/Searcher"
import { docsOptions, menuOptions } from "../../../data/layout-test-data"
import CollapseMenu from "../../../components/Collapse/CollapseMenu"
import Hours from "../../../components/Hours"
import NewsTabHead from "../../../components/NewsTab/NewsTabHead"
import NewsTabContent from "../../../components/NewsTab/NewsTabContent"
import { activities1 } from "../../../data/news-tab"
import parse from "react-html-parser"
import { activityContent1 } from "../../../data/activityTab"
import NewsTabIframe from "../../../components/NewsTab/NewsTabIframe"
import NewsTabSocial from "../../../components/NewsTab/NewsTabSocial"
import NewsTabImage from "../../../components/NewsTab/NewsTabImage"
import NewsTabVideos from "../../../components/NewsTab/NewsTabVideos"
import NewsTabActivities from "../../../components/NewsTab/NewsTabActivities"
import NewsTabItem from "../../../components/NewsTab/NewsTabItem"

export default function ActivityTab() {
  const path = [
    { label: "Inicio", to: "/" },
    { label: "Servicios y actividades", to: "/servicios-y-actividades" },
    { label: "Exámenes", to: "/examenes-web" },
    { label: "1a Convocatoria 2021 examen EFP (European Financial Planner)" },
  ]
  return (
    <Layout>
      <Hero image="/imgs/servicios-actividades-ret.jpg" text="Exámenes" />
      <div className="container950">
        <Breadcrumb path={path} />
        <Searcher />
        <div className="row efpa-row">
          <div className="col-12 col-md-3 Topicality-padding-col">
            <CollapseMenu list={menuOptions} title="Menú" />
            <div className="d-none d-md-block">
              <Hours
                list={menuOptions}
                showTitle={false}
                className="LayoutTest-options"
              />
            </div>
          </div>
          <div className="col-12 col-md-9 Topicality-col-9">
            <NewsTabHead
              title="1a Convocatoria 2021 examen EFP (European Financial Planner)"
              subtitle="De 11:30h a 13:30h y de 15h a 19h"
            />
            <NewsTabContent
              reverse
              content={activities1}
              image="/imgs/newstab-image-2.jpeg"
            />
            <div className="ActivityTab-content">
              {parse(activityContent1.content)}
            </div>
            <NewsTabIframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/Cv2pZ6ZvYC8"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen=""
            />
            <div className="ActivityTab-section">
              <div className="ActivityTab-sectionTitle">
                Documentos actividad
              </div>
              <Hours
                list={docsOptions}
                showTitle={false}
                className="LayoutTest-options"
              />
            </div>
            <div className="NewsTab-borderTop">
              <div className="ActivityTab-twitter">
                <i className="fa-brands fa-x-twitter"></i>
                <span>
                  Te invitamos a participar en X, haciendo llegar tus
                  comentarios a #HASHTAGTWITTER
                </span>
              </div>
            </div>
            <div className="NewsTab-borderTop">
              <NewsTabSocial />
            </div>
            <NewsTabImage />
            <NewsTabVideos />
            <NewsTabActivities />
            <NewsTabItem />
          </div>
        </div>
      </div>
    </Layout>
  )
}
